// ============================================================================
// note-client-mod -- useNoteToggle Hook
//
// 置顶 / 归档 / 收藏 三合一 toggle mutation。
// 返回更新后的 INote，调用方可用它本地更新列表。
// ============================================================================
import { useState, useCallback } from 'react';
import { getNoteApiClient } from '../note-api-client.js';
export function useNoteToggle() {
    const [toggling, setToggling] = useState(null);
    const [error, setError] = useState(null);
    const toggle = useCallback(async (id, kind) => {
        setToggling(kind);
        setError(null);
        try {
            const client = getNoteApiClient();
            switch (kind) {
                case 'pin': return await client.togglePin(id);
                case 'archive': return await client.toggleArchive(id);
                case 'favorite': return await client.toggleFavorite(id);
            }
        }
        catch (err) {
            setError(err instanceof Error ? err.message : '操作失败');
            return null;
        }
        finally {
            setToggling(null);
        }
    }, []);
    return { toggling, error, toggle };
}
//# sourceMappingURL=use-note-toggle.js.map